/**
 * Safely parses a JSON string
 * @param jsonString - JSON string to parse
 * @returns Parsed object or null if an error occurred
 */
export const safeJsonParse = <T = any>(jsonString: string): T | null => {
  if (!jsonString || typeof jsonString !== 'string') {
    return null;
  }

  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    console.warn('Failed to parse JSON:', error);
    return null;
  }
};

/**
 * Safely serializes an object to JSON string
 * @param data - Data to serialize
 * @returns JSON string or null if an error occurred
 */
export const safeJsonStringify = (data: any): string | null => {
  try {
    return JSON.stringify(data);
  } catch (error) {
    console.warn('Failed to stringify JSON:', error);
    return null;
  }
};
